// extracted by mini-css-extract-plugin
module.exports = {"loadingWrp":"loading_loadingWrp__3ZLF8","icon":"loading_icon__N0RzK"};